import * as Types from '../../../generated/webapp_gql';

import { ScreenSectionFragment, ContentLink_AssessmentLinkNode_Fragment, ContentLink_CircleSeriesLinkNode_Fragment, ContentLink_CircleSessionLinkNode_Fragment, ContentLink_CircleTopicLinkNode_Fragment, ContentLink_CourseLinkNode_Fragment, ContentLink_ExternalLinkNode_Fragment, ContentLink_HrEventLinkNode_Fragment, ContentLink_HrResourceLinkNode_Fragment, ContentLink_InternalLinkNode_Fragment, ContentLink_MeditationLinkNode_Fragment, ContentLink_ProgramLinkNode_Fragment, ContentLink_ScreenLinkNode_Fragment } from '../../dashboard/documents/getHomeScreen.generated';
import { ProgramPreviewFragment } from '../../newPrograms/documents/getProgram.generated';
import { gql } from 'graphql.macro';
import { ScreenSectionFragmentDoc, ContentLinkFragmentDoc } from '../../dashboard/documents/getHomeScreen.generated';
import { ProgramPreviewFragmentDoc } from '../../newPrograms/documents/getProgram.generated';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ExploreScreenFragment = (
  { __typename: 'ExploreScreenNode' }
  & Pick<Types.ExploreScreenNode, 'id' | 'uuid' | 'name' | 'platform'>
  & { topics: Array<(
    { __typename: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  )>, activities?: Types.Maybe<(
    { __typename?: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  )> }
);

export type GetExplorePageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetExplorePageQuery = (
  { __typename?: 'Query' }
  & { exploreScreen?: Types.Maybe<(
    { __typename: 'ExploreScreenNode' }
    & ExploreScreenFragment
  )> }
);

export const ExploreScreenFragmentDoc = gql`
    fragment ExploreScreen on ExploreScreenNode {
  id
  uuid
  name
  platform
  topics {
    id
    ...ScreenSection
    __typename
  }
  activities {
    id
    ...ScreenSection
  }
  __typename
}
    ${ScreenSectionFragmentDoc}`;
export const GetExplorePageDocument = gql`
    query getExplorePage {
  exploreScreen(platform: WEB) {
    __typename
    ...ExploreScreen
  }
}
    ${ExploreScreenFragmentDoc}
${ScreenSectionFragmentDoc}
${ContentLinkFragmentDoc}
${ProgramPreviewFragmentDoc}`;
export type GetExplorePageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetExplorePageQuery, GetExplorePageQueryVariables>, 'query'>;

    export const GetExplorePageComponent = (props: GetExplorePageComponentProps) => (
      <ApolloReactComponents.Query<GetExplorePageQuery, GetExplorePageQueryVariables> query={GetExplorePageDocument} {...props} />
    );
    
export type GetExplorePageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetExplorePageQuery, GetExplorePageQueryVariables>
    } & TChildProps;
export function withGetExplorePage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetExplorePageQuery,
  GetExplorePageQueryVariables,
  GetExplorePageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetExplorePageQuery, GetExplorePageQueryVariables, GetExplorePageProps<TChildProps, TDataName>>(GetExplorePageDocument, {
      alias: 'getExplorePage',
      ...operationOptions
    });
};

/**
 * __useGetExplorePageQuery__
 *
 * To run a query within a React component, call `useGetExplorePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExplorePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExplorePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExplorePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExplorePageQuery, GetExplorePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExplorePageQuery, GetExplorePageQueryVariables>(GetExplorePageDocument, options);
      }
export function useGetExplorePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExplorePageQuery, GetExplorePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExplorePageQuery, GetExplorePageQueryVariables>(GetExplorePageDocument, options);
        }
export type GetExplorePageQueryHookResult = ReturnType<typeof useGetExplorePageQuery>;
export type GetExplorePageLazyQueryHookResult = ReturnType<typeof useGetExplorePageLazyQuery>;
export type GetExplorePageQueryResult = ApolloReactCommon.QueryResult<GetExplorePageQuery, GetExplorePageQueryVariables>;